import React from 'react';
import PropTypes from 'prop-types';
import { CFM_BANANA } from 'constants/Colors';

const Filter = ({ isActive }) => {
    if (isActive) {
        return (
            <svg
                width="18px"
                height="18px"
                viewBox="0 0 18 18"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs>
                    <polygon
                        id="star-filled-path"
                        points="7 6.12765957 1 6.12765957 6 9.87234043 4 16 9 12.2553191 14 16 12 9.87234043 17 6.12765957 11 6.12765957 9 0"
                    />
                </defs>
                <g
                    id="Svg-Icons/18px-(All-icons)/UI/star-filled"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <mask id="mask-2" fill="white">
                        <use xlinkHref="#star-filled-path" />
                    </mask>
                    <use
                        id="Star"
                        className="icon-color"
                        fill={CFM_BANANA}
                        xlinkHref="#star-filled-path"
                    />
                </g>
            </svg>
        );
    }
    return (
        <svg
            width="18px"
            height="18px"
            viewBox="0 0 18 18"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <path
                    d="M9,2.87072015 L7.64067486,7.03546099 L3.7152384,7.03546099 L7.04817841,9.53162032 L5.72641151,13.5812891 L9,11.1295803 L12.2735885,13.5812891 L10.9518216,9.53162032 L14.2847616,7.03546099 L10.3593251,7.03546099 L9,2.87072015 Z M7,6.12765957 L9,0 L11,6.12765957 L17,6.12765957 L12,9.87234043 L14,16 L9,12.2553191 L4,16 L6,9.87234043 L1,6.12765957 L7,6.12765957 Z"
                    id="star-outline-path"
                />
            </defs>
            <g
                id="Svg-Icons/18px-(All-icons)/UI/star-outline"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <mask id="mask-2" fill="white">
                    <use xlinkHref="#star-outline-path" />
                </mask>
                <use id="Stroke-62-Copy" fill="#0576b9" xlinkHref="#star-outline-path" />
            </g>
        </svg>
    );
};

Filter.propTypes = {
    isActive: PropTypes.bool,
};

export default Filter;
